
define('stache!uni-e-fi/mustache/costItemAutoInputTemplate', ['mustache'], function (mustache) {
    var template = '{{! stache!uni-e-fi/mustache/costItemAutoInputTemplate }}\r\n<div id="autoInput-select-condition" class="unidocu-form-table-wrapper" style="margin-top: 10px; display: none;"></div>';
    mustache.parse(template);
    return function (view, partials) {
        var additionalKeys = [];
        $.each(template.split('{{{'), function(index, item){if(!/}}}/.test(item)) return true;var key = item.split('}}}')[0];if(/[가-힣]/.test(key)) additionalKeys.push(key);});
        $.each(partials, function(partialIndex, partial){$.each(partial.split('{{{'), function(index, item){if(!/}}}/.test(item)) return true;var key = item.split('}}}')[0];if(/[가-힣]/.test(key)) additionalKeys.push(key);});});
        if($.isArray(view)) throw 'stacheCustom: cannot use array type view';
        view = $.extend({}, view, {contextPath: staticProperties.contextPath, requireBust: staticProperties.requireBust});
        if(additionalKeys.length > 0 && $u && $mls) view = $.extend({}, $mls.getMustacheView(additionalKeys), view);        return mustache.render(template, view, partials);
    }
});
